<template>
  <!-- Payout -->
  <PayoutAdd v-if="isPayout"></PayoutAdd>
  <!-- 非 Payout -->
  <NormalAdd v-else></NormalAdd>
</template>
<script>
import { mapGetters } from 'vuex';

import NormalAdd from '@/views/collection/virtual-account/add/normal.vue';
import PayoutAdd from '@/views/collection/virtual-account/add/payout.vue';

export default {
  components: {
    NormalAdd,
    PayoutAdd,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      isPayout: false,
    };
  },
  created() {
    // 商户类型
    try {
      const userLogin = this.app.userLogin;
      if (userLogin && userLogin.businessType === '0') {
        this.isPayout = true;
      } else if (userLogin && userLogin.businessType === '2') {
        this.isPayout = false;
      }
    } catch (error) {
      //
    }
  },
};
</script>
